import type { WikiTopic } from "../types.js";
import { confluence } from "./confluence.js";
import { emaCross } from "./ema-cross.js";
import { gapDetector } from "./gap-detector.js";
import { hourlyCross } from "./hourly-cross.js";
import { momentumPivot } from "./momentum-pivot.js";
import { volumeBreakout } from "./volume-breakout.js";

/**
 * The six producers that mean to be flat by the close, in registry order.
 *
 * Registry order rather than alphabetical, so the rail reads in the order
 * `ALL_STRATEGY_SETS` evaluates them and confluence lands last, after the five
 * strategies whose votes it counts.
 */
export const sessionStrategies: readonly WikiTopic[] = [
  emaCross,
  hourlyCross,
  volumeBreakout,
  momentumPivot,
  gapDetector,
  confluence,
];
